<script>import SVGRoot from "./../SVGRoot.svelte";
import SVGGPieChart from "./pie/SVGGPieChart.svelte";
import SVGGBarChart from "./bar/SVGGBarChart.svelte";
import { okhsl } from "../../../d3-mapp/color/index.js";
export let tag = "";
export let type = "auto";
export let aspectRatio;
export let size = void 0;
export let padding = 5;
export let defaultFill = okhsl("transparent");
export let data;
export let axisUnit;
export let label;
export let value = (d) => d.value;
export let onLabel = (datum) => datum.value.toString();
export let centerLabel = (data2) => Object.values(data2.distribution).reduce((sum, d) => sum + d.value, 0).toString();
export let innerRadius = 0.4;
export let outerRadius = 0.8;
export let tickRadius = 0.9;
export let centerTextSize = 0.8;
export let duration = 400;
export let showLabel = true;
export let showOnLabel = true;
const reactiveSize = size === void 0;
$:
  categoryCount = Object.keys(data.distribution).length;
let chartType;
$:
  chartType = type === "auto" ? categoryCount > 6 ? "hbar" : "pie" : type;
let barSize = 20;
let hBarAxisSize = 30;
let vBarAxisSize = 40;
let rootSize;
let viewBox;
let width;
let height;
$: {
  if (reactiveSize && rootSize) {
    size = rootSize.width / aspectRatio;
  }
}
$: {
  width = chartType === "pie" || chartType === "hbar" ? size != void 0 ? size * aspectRatio : void 0 : categoryCount * barSize + vBarAxisSize;
  height = chartType === "pie" ? size : chartType === "hbar" ? categoryCount * barSize + hBarAxisSize : size;
  viewBox = width !== void 0 && height != void 0 ? [width, height] : void 0;
}
</script>

<SVGRoot bind:bounds={rootSize} {viewBox} {tag}>
	{#if chartType === 'pie' && size !== undefined}
		<SVGGPieChart
			{size}
			{aspectRatio}
			{padding}
			{defaultFill}
			{data}
			{label}
			{value}
			{onLabel}
			{centerLabel}
			{innerRadius}
			{outerRadius}
			{tickRadius}
			{centerTextSize}
			{duration}
			{showLabel}
			{showOnLabel}
		/>
	{:else if width !== undefined && height != undefined}
		<SVGGBarChart
			orientation={chartType === 'vbar' ? 'vertical' : 'horizontal' }
			{width}
			{height}
			{padding}
			{defaultFill}
			{data}
			{barSize}
			{label}
			{value}
			{centerLabel}
			{duration}
			{axisUnit}
		/>
	{/if}
</SVGRoot>
